import { render, staticRenderFns } from "./ReviewsTable.vue?vue&type=template&id=72fba5b3"
import script from "./ReviewsTable.vue?vue&type=script&lang=js"
export * from "./ReviewsTable.vue?vue&type=script&lang=js"
import style0 from "./ReviewsTable.vue?vue&type=style&index=0&id=72fba5b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports